import React from 'react';

const Container = ({ children }) => (
  <aside className="touch-scroll">
    {children}
  </aside>
)

export default Container
